import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import CheckInScreen from '../components/CheckInScreen';

import { inserirAtendimento } from '../api/atendimentosApi';
import QRCodeBox from '../components/QRCodeBox';
import { supabase } from '../services/supabaseClient';

const CheckInPage = () => {
  const navigate = useNavigate();
  const { loginUser, setAtendimentoId, setIsMensalista, isQrMode } = useApp();

  // Função para processar check-in (seja manual ou mobile)
  // Função para buscar o mensalista pelo nome (retorna objeto ou null)
  async function buscarMensalistaPorNome(nome) {
    const { data, error } = await supabase
      .from('mensalistas')
      .select('id, nome, status')
      .eq('status', 'ativo');
    if (error || !data) return null;
    // Busca nome igual (case-insensitive)
    return data.find(m => m.nome.trim().toLowerCase() === nome.trim().toLowerCase()) || null;
  }

  const processCheckIn = useCallback(async (userData) => {
    // Busca mensalista pelo nome (pode retornar null se não for mensalista)
    const mensalistaObj = await buscarMensalistaPorNome(userData.name);
    const isMensalista = !!mensalistaObj;
    try {
      let atendimento;

      if (userData.atendimentoId) {
        // Se já existe um atendimento (caso mobile), apenas atualiza o status
        const { data, error } = await supabase
          .from('atendimentos')
          .update({
            status: 'ativo',
            mensalista: isMensalista,
            mensalista_id: mensalistaObj ? mensalistaObj.id : null
          })
          .eq('id', userData.atendimentoId)
          .select()
          .single();

        if (error) throw error;
        atendimento = data;
      } else {
        // Caso contrário, cria um novo atendimento
        atendimento = await inserirAtendimento({
          nome_cliente: userData.name,
          telefone: userData.phone || '',
          mensalista: isMensalista,
          mensalista_id: mensalistaObj ? mensalistaObj.id : null,
          barbeiro: 'Não definido',
          status: 'ativo',
        });
      }

      if (atendimento && atendimento.id) {
        setAtendimentoId(atendimento.id);
      }

      // Atualizar o usuário atual
      loginUser({
        name: userData.name,
        phone: userData.phone || '',
      });
      
      // Definir se é mensalista
      setIsMensalista(isMensalista);
      
      // Navegar para a próxima página com base no status de mensalista
      if (isMensalista) { // Mudar condição para isMensalista
        navigate('/welcome');
      } else {
        navigate('/menu');
      }
    } catch (error) {
      console.error('Erro ao processar check-in:', error);
    }
  }, [loginUser, setAtendimentoId, setIsMensalista, navigate]);

  const handleBack = () => {
    navigate('/');
  };

  const handleAdminLogin = () => {
    navigate('/admin-login');
  };

  const handleCheckIn = async (userData) => {
    if (isQrMode) {
      return <QRCodeBox url={window.location.origin + '/mobile/checkin'} />;
    }
    
    await processCheckIn(userData);
  };

  const onResumeSession = (session) => {
    // Retoma sessão: define atendimento, autentica usuário e mostra menu
    setAtendimentoId(session.id);
    // Reconstroi currentUser para sessão existente
    loginUser({ 
      name: session.nome_cliente, 
      phone: session.telefone || '' 
    });
    setIsMensalista(session.mensalista);
    
    // Navegar diretamente para o menu principal ao retomar uma sessão
    navigate('/menu');
  };

  return (
    <CheckInScreen
      onCheckIn={handleCheckIn}
      onBack={handleBack}
      onResumeSession={onResumeSession}
      onAdminLogin={handleAdminLogin}
    />
  );
};

export default CheckInPage;
